document.addEventListener("DOMContentLoaded", function() {
    //const button = document.querySelector('.ate__show-modal');
    //console.log(button);
    //button.onclick = showATEModal;

    const closers = document.querySelectorAll('.modal-closer');
    //console.log(closers);
    closers.forEach(closer => {
        closer.onclick = hideATEModal;
        //console.log("bind closer", closer);
    });


    //console.log("Bind Closer button", closers);


    const continueShopping = document.querySelector('.continue-shopping');
    continueShopping.onclick = hideATEModal;
    const modalBlocker = document.querySelector('.modal-blocker');
    modalBlocker.onclick = hideATEModal;
});

function showATEModal(event){
    //console.log("SHOW MODAL");
    if(event) {
        const modalId = event.target.dataset.modalid;
    }
    const modal = document.querySelector('#modal-ate');
    const modalBlocker = document.querySelector('.modal-blocker');
    modal.classList.remove("hidden");
    modalBlocker.classList.remove("hidden");
    modalBlocker.classList.add("ate__scroll-lock");
    const body = document.querySelector("body");
    body.classList.add("ate__scroll-lock");
    resetATEModal();
}

function resetATEModal(){
    const qtyInputs = document.querySelectorAll(".atc-grid .quantity__input");
    qtyInputs.forEach(input => {
       input.value = 1;
    });
}

function hideATEModal(event){
    console.log('hideModal');
    console.log(event);
    const modalId = event.currentTarget.dataset.modalid;
    const modal = document.querySelector('#modal-ate');
    const modalBlocker = document.querySelector('.modal-blocker');

     //console.log(modal);
     //console.log(modal.classList);
     //console.log(modal.classList.contains("hidden"));
    if(!modal.classList.contains("hidden")) {
        modal.classList.add("hidden");
    }
    if(!modalBlocker.classList.contains("hidden")) {
        modalBlocker.classList.add("hidden");
    }
    modalBlocker.classList.remove("ate__scroll-lock");
    const body = document.querySelector("body");
    body.classList.remove("ate__scroll-lock");
}


